import { mapMutations } from 'vuex';
import { BehaviorSubject } from 'rxjs';

import { IFRAME_EVENT_MESSAGE, WIDGET_TYPES } from '@/utils/consts';
import { isValueExist, useReactState } from '@/utils/utils';
import {
    checkSourceTableMode,
    refineChannel,
    refineSourceNameWithDeprecated,
} from '@/utils/dashboard';
import { filterSelected } from '@/components/Dashboard/common/WidgetSettingPanel';

import DataSource, {
    UNSELECT_ALREADY_SELECTED,
} from '@/components/Dashboard/common/WidgetSettingPanel/options/dataSource';

const { AUTOMATION } = WIDGET_TYPES;

export default {
    setup() {
        const [dataSourceData_, setDataSourceData_] = useReactState({});

        return {
            dataSourceData_,
            setDataSourceData_,
        };
    },
    data() {
        return {
            secondPanelVisibility$: new BehaviorSubject(null),
        };
    },
    provide() {
        return {
            secondPanelVisibility$: this.secondPanelVisibility$,
        };
    },
    mounted() {
        this.$nextTick(() => {
            this.addAutomationIframeListener_();
        });
    },
    methods: {
        ...mapMutations('newDashboard', ['setShowTopBtn']),
        addAutomationIframeListener_() {
            const listeners = [
                {
                    eventType: IFRAME_EVENT_MESSAGE.TOP_BTN_SHOW,
                    listener: () => {
                        this.setShowTopBtn(true);
                        this.loadChatbot();
                    },
                },
                {
                    eventType: IFRAME_EVENT_MESSAGE.TOP_BTN_HIDE,
                    listener: () => {
                        this.setShowTopBtn(false);
                        this.hideChatbot();
                    },
                },
                {
                    eventType:
                        IFRAME_EVENT_MESSAGE.OPEN_DATA_SOURCE_SECOND_PANEL,
                    listener: (event) => {
                        this.clearPanelData_();

                        const {
                            adAccounts,
                            compKey,
                            teamspaceAllowedChannelIds,
                            teamspaceAllowedAssetIds,
                        } = event.data;

                        this.setDataSourceData_(event.data);
                        this.setTableAdAccounts(adAccounts);
                        this.setTeamspaceAllowedChannelIds(
                            teamspaceAllowedChannelIds
                        );
                        this.setTeamspaceAllowedAssetIds(
                            teamspaceAllowedAssetIds
                        );
                        this.secondPanelVisibility$.next(compKey);
                    },
                },
            ];

            this.iframeListeners_.push(...listeners);
            console.log('Automation mounted::');
        },
        clearPanelData_() {
            this.setDataSourceData_({});
            this.secondPanelVisibility$.next(null);
        },
        renderDataSource_() {
            if (!isValueExist(this.dataSourceData_)) {
                return null;
            }

            const indexKey = 'assetId';
            const translator = refineSourceNameWithDeprecated.bind(this);

            const {
                ignoreIsAnalytic,
                isAnalytic,
                currentList,
                rawList,
                compKey,
                localeKey,
                disabled,
                showAddConnection,
                hasEditBtn,
            } = this.dataSourceData_;

            const selectedList = filterSelected(currentList);

            const props = {
                class: 'alarm-rule-setting-second-panel__dataSource',
                attrs: {
                    ignoreIsAnalytic,
                    isAnalytic,
                    currentList,
                    selectedList,
                    rawList,
                    indexKey,
                    compKey,
                    localeKey,
                    disabled,
                    showAddConnection,
                    hasEditBtn,
                    translator,
                    hide: true,
                    widgetType: AUTOMATION,
                    analyticGenerateOption: (item) => {
                        const { isSupportMultiDatasources = false } = item;
                        const itemChannel = refineChannel(item);

                        let options = [UNSELECT_ALREADY_SELECTED];
                        let message = this.$t(
                            'NEW_DASHBOARD.change_source_mode_modal_basic_desc'
                        );

                        const selectedChannel = R.compose(
                            refineChannel,
                            R.head
                        )(selectedList);

                        if (
                            itemChannel === selectedChannel &&
                            isSupportMultiDatasources
                        ) {
                            options = [];
                        }

                        return {
                            options,
                            message,
                        };
                    },
                },
                on: {
                    update: (dataSources) => {
                        const mode = R.compose(
                            checkSourceTableMode,
                            filterSelected
                        )(dataSources);

                        let data = R.assoc(
                            'currentList',
                            dataSources
                        )(this.dataSourceData_);

                        if (!ignoreIsAnalytic && mode !== 'toggleable') {
                            data = R.assoc(
                                'isAnalytic',
                                mode === 'analytic'
                            )(data);
                        }

                        // vue update
                        this.setDataSourceData_(data);

                        // react update
                        this.postIframeMessage({
                            type: IFRAME_EVENT_MESSAGE.AUTOMATION_DATA_SOURCE_ON_UPDATE,
                            origin: `VUE`,
                            data: {
                                dataSources,
                            },
                        });
                    },
                },
            };

            return <DataSource {...props} />;
        },
    },
};
